import { render, staticRenderFns } from "./orderAssess.vue?vue&type=template&id=39e1a7ed&scoped=true&"
import script from "./orderAssess.vue?vue&type=script&lang=js&"
export * from "./orderAssess.vue?vue&type=script&lang=js&"
import style0 from "./orderAssess.vue?vue&type=style&index=0&id=39e1a7ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e1a7ed",
  null
  
)

export default component.exports